import React, {Component} from 'react';
import {siteAccessCode} from '../../database/apiv2SiteAccessor';
import {urlDeviceInfo} from '../../database/apiUrls'
import SecondServer from '../../database/SecondServer'
import SwapDevice from './SwapDevice'
import { cachedPerms, canWrite } from "../../Overview/SitePerms"

import '../../Overview/overview.css'
import './controls.css'
import './devicepanel.css'

export default class DevicePanel extends Component {
  constructor(props) {
    super(props);

    this.state = {
      renderMode: 'this',
      location_note: '',
      readwrite: 'readOnly',
      apt: this.props.deviceMeta[0]?.Apt ?? '',
      bldg: this.props.deviceMeta[0]?.Building ?? '',
      nodeId: this.props.deviceMeta[0]?.NodeId ?? '',
      address: '',
      city: '',
      state: '',
      zip: '',
    };
    this.imageMap = [ {type: "TW_191_R", image: "TW191-R-500T.png"},
                      {type: "TW_177", image: "TW-177-500T.png"} ,
                      {type: "TW_175", image: "TW-175-500T.png"} ,
                      {type: "DCAP", image:"DCAP-500T.png"}, 
                      {type: "TW_170B_P", image: "170B-P500T.png"},
                      {type: "TW_170B_E", image: "170B-E500T.png"},
                      {type: "TW_160B_E", image: "160B-E500T.png"},
                      {type: "TW_160B_P", image: "160B-P500T.png"},
                      {type: "MDT", image: "160B-P500T.png"},
                    ]

    this.swapClick = this.swapClick.bind(this);
    this.toggleEditMode= this.toggleEditMode.bind(this)
    this.handleEdit = this.handleEdit.bind(this)
  }

  async componentDidMount () {
    const site = this.props.getActiveSite();
    const ss = new SecondServer(this.props);
    try {
      const url = urlDeviceInfo (this.props.deviceId, siteAccessCode(site))
      const resp = ss.throwOnError(await ss.apiData(url))
      const saveLoc = resp?.data?.data?.location_note ?? ''
      //console.log (resp)
      //console.log (this.props.deviceMeta[0])
      // want resp.data.data.node_id and resp.data.data.address
      this.setState({"location_note": saveLoc, address: resp?.data?.data?.address ?? ''})
    }
    catch (e) {/*todo*/}
  }
  bestPic () {
    const myProfile = this.props?.dcfg?.Config_As ?? "MDT"
    return this.imageMap.find(i => i.type === myProfile)?.image ?? "160B-P500T.png"
  }
  async swap (newDevice, isCommissioned) {
    //const siteId = siteAccessCode(this.props.getActiveSite());
    //const ss = new SecondServer(this.props)
    try {
      // ss.throwOnError (await addDevice (siteId, newDevice, ss), "Add device API")
      const oldDevice = this.props?.deviceMeta[0]
      const apiInfo = {
        node_id: oldDevice?.NodeId ?? '',
        //address: oldDevice?.address ?? '',
        building: this.state.bldg,
        apt: this.state.apt,
        location_note: this.state.location_note,
      }
      console.log (apiInfo, newDevice, oldDevice, this.props)
      //ss.throwOnError(await setDeviceInfo (siteId, newDevice, apiInfo, ss), "Set up device")
      //const arrSensor = this.getSensors(oldDevice.sensors, [0,1,2])
      /*ss.throwOnError (await setNewSensorInfo(siteId, newDevice, arrSensor, ss), "Add sensors")
      ss.throwOnError (await decommission(oldDevice.DeviceId, siteId, ss), "Decommission old MDT")
      this.refresh()*/
    }
    catch(err) {
      this.setState({errorMsg: err.message})
    }
  }
  async swapClick(ok, newdevice, commissioned) {
    if (ok) {
      await this.swap (newdevice, commissioned)
    }
     this.swapMode('this')
  }
  swapMode (mode) {
    // not working
    //this.setState({renderMode: mode})
  }
  editMode () {
    return this.state.readwrite === 'readOnly'
  }
  canEdit() {
    return canWrite(cachedPerms(this.props.getActiveSite()))
  }
  toggleEditMode () {
    if (this.canEdit()) {
      if (!this.editMode ()) {
        this.saveState()
      }
      const newState = this.editMode() ? '': 'readOnly'
      this.setState({readwrite: newState})
    }
  }
  editLabel () {
    return this.editMode() ? "Edit" : "Save"
  }
  saveState() {
    const ss = new SecondServer(this.props);
    const site = this.props.getActiveSite();
    const deviceId = this.props.deviceId;
    let url = '/tehama/sites/devices/'+deviceId+'?access_code='+siteAccessCode(site);
    let saveObj = {
      apt: this.state.apt,
      building: this.state.bldg,
      location_note: this.state.location_note,
      address: this.state.address,
      node_id: this.state.nodeId,
    }
    ss.apiSaveData(url, saveObj)
  }
  handleEdit (evt) {
    let item = {}
    item[evt.target.id] = evt.target.value
    this.setState({...item})
    //console.log ("You changed ", evt.target.id, " to ", item.value);
  }
  textInput (label, prop, className='') {
    const data = this.state[prop]
    const rw = this.editMode()
    const borderStyle = this.editMode() ? " display-style" : " input-border"
    return (
      <label className={"form-label site-label "+className}>{label}
        <input type="text" id={prop} className={"form-control"+borderStyle}  
          onChange={this.handleEdit} value={data} readOnly={rw}/>
      </label>
    )
  }
  fixedInput (label, data, className='') {
    return (
      <label className={"form-label site-label "+className}>{label}
        <input type="text" defaultValue={data} id={label} className={"form-control display-style"} readOnly />
      </label>
    )
  }
//<span className="swap-link" onClick={()=>this.swapMode('swap')}>Swap Device</span>
  render() {
    const el = this.editLabel()
    const selfie = this.bestPic ()
    const swapData = {...this.props.deviceMeta[0], device_id:this.props.deviceMeta[0].DeviceId}
    return (
      <div className="device-container">
        <div className="device-selfie-container">
          <img className="device-selfie" src={selfie} alt="mdt" />
        </div>
        <div className="device-name">{this.props.deviceMeta[0]?.Type??"MDT"}&nbsp;{this.props.deviceId}
        </div>
        <div className="site-edit dev-edit-place" onClick={this.toggleEditMode}>{el}</div>
        <div className= "device-form-container">
          <form>
            <div className="row">
              <div className="col">{this.fixedInput("Radio ID", this.props.deviceId)}</div>
              <div className="col">{this.textInput("Apt", 'apt')}</div>
              </div>
            <div className="row">
              <div className="col">{this.textInput("Building", 'bldg')}</div>
              <div className="col">{this.textInput("Node Id", 'nodeId')}</div>
              </div>
              <div className="row">
              <div className="col">{this.textInput("Address", 'address', 'w-100')}</div>
            </div>
            <div className="row">
              <div className="col">{this.textInput("Location Note", 'location_note', 'w-100')}</div>
            </div>
          </form>
        </div>
        <SwapDevice show={this.state.renderMode === 'swap'} onHide={this.swapClick}
                   {...this.props} devices={[swapData]} />
      </div>
    );
  }
}
